export default "__VITE_ASSET__BJgjonQ___"